import React from 'react';
import MatGapCoreTransactionList from './MatGapCoreTransactionList';

export default function MatGapAssignmentList() {
  return (
    <MatGapCoreTransactionList
      title="GAP Material - Assignment Transactions"
      opTypes={["assign"]}
    />
  );
}
